import { configRequest } from 'config-request';
import { defineStore } from 'pinia';
import { useGlobalStore } from './global';
import { useFeatureListStore } from './feature-list';
import { useQuotationStore } from './quotation';
import { getRequestIns } from '../requestIns';
export const useSaveQuotationStore = defineStore('save-quotation', {
    actions: {
        /**
         * 保存报价单
         */
        async saveQuotation(token, params, appId) {
            const globalStore = useGlobalStore();
            const featureListStore = useFeatureListStore();
            const quotationStore = useQuotationStore();
            const optionMap = featureListStore.data?.option_map;
            const option_list = params?.option_list?.length
                ? params?.option_list
                : globalStore.currentOptionList.map((item) => ({
                    ...item,
                    name: optionMap?.[item.code]?.name ?? '',
                }));
            const saveParams = Object.assign({
                generation_code: globalStore.currentOptions.generation_code,
                model_code: globalStore.currentOptions.model_code,
                new_version: globalStore.newVersion,
                option_list: option_list,
                total_price: quotationStore?.data?.price_info?.total_price,
                discount_price: quotationStore?.data?.discount_price,
                baas_deduction_price: quotationStore?.data?.baas_deduction_price,
                subsidy_price: quotationStore?.data?.subsidy_price,
                promotion_packages: quotationStore?.data?.promotion_packages,
                business_discount: quotationStore?.data?.business_discounts,
            }, params);
            const result = await configRequest(getRequestIns()).saveQuotation(saveParams, {
                header: {
                    token,
                    Authorization: `Bearer ${token}`,
                },
                showToast: true,
                throwError: true,
                appId,
            });
            return result?.data ?? null;
        },
    },
});
